export class Protocolo{
    status: number;
    descricao: string;
    data: number;
}